<template>
  <div>
    <div class="topBox">
      <div class="top container">
        <Logo></Logo>
        <div class="title">
          <div class="navLink">
            <router-link to="/home">首页</router-link>
            <router-link to="/apiMarget">API列表</router-link>
            <router-link to="/resourceDownload">图书资源包下载</router-link>
            <!-- <router-link to="/otherResourceDownload">其他资源</router-link> -->
          </div>
          <div class="btn" v-if="!userInfo.token">
            <button class="login" @click="login">登录</button>
            <button class="register" @click="reg">注册</button>
          </div>
          <div
            class="user"
            v-else
            @mouseenter="logoutMyapiFlag = true"
            @mouseleave="logoutMyapiFlag = false"
          >
            <button class="userCenter" @click="$router.push('/userLayout')">
              个人中心
            </button>
            <div class="logout-myapi" v-show="logoutMyapiFlag">
              <div class="logout" @click="logout">退出登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import { mapState } from 'vuex'
import { logout } from '@/api/common'
export default {
  name: 'LayoutIndex',
  data () {
    return {
      logoutMyapiFlag: false
    }
  },
  methods: {
    login () {
      this.$router.push('/login')
    },
    reg () {
      this.$router.push('/reg')
    },
    async logout () {
      await logout()
      this.$store.commit('removeUserInfo')
      this.$router.push('/').catch((err) => {
        if (err.name !== 'NavigationDuplicated') {
          throw err // 重新抛出其他类型的错误
        }
      })
    }
  },
  components: { Logo },
  computed: {
    ...mapState(['logoUrl', 'userInfo'])
  }
}
</script>

<style lang="less" scoped>
.topBox {
  border-bottom: 1px solid #e7e1e1;
}
.top {
  height: 60px;
  //   background-color: pink;
  display: flex;
  justify-content: space-between;
  .title {
    width: 1000px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user {
      position: relative;
      .userCenter {
        height: 38px;
        padding: 0 18px;
        background: linear-gradient(135deg, #409EFF, #67C23A);
        border: none;
        color: #fff;
        border-radius: 19px;
        cursor: pointer;
      }
      .logout-myapi {
        position: absolute;
        top: 38px;
        left: 0;
        width: 120px;
        padding: 0 10px;
        color: #463d3d;
        background-color: #fff;
        font-size: 15px;
        border: 1px solid #f5f2f2;
        .logout {
          margin: 5px 0;
          cursor: pointer;
        }
      }
    }
    .navLink {
      color: #333;
      font-size: 17px;
      width: 450px;
      display: flex;
      justify-content: space-around;
    }
    .btn {
      width: 160px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .login {
        height: 38px;
        padding: 0 18px;
        background: linear-gradient(135deg, #409EFF, #67C23A);
        border: none;
        color: #fff;
        border-radius: 19px;
        cursor: pointer;
      }
      .register {
        height: 38px;
        padding: 0 18px;
        background-color: #f3eeee;
        border: none;
        color: #5f5f5f;
        border-radius: 19px;
        border-color: #d2d2d2;
        cursor: pointer;
      }
    }
  }
}
.router-link-active {
  color: orange;
}
</style>
